/* REQ-010 · Ran 20.10 · "עריכת ההקדשה" edits the line inside the cart (drawer or /cart), never on the product page.
   One design: the sticker editor opens over the cart. Several designs: the designs manager opens over the cart.
   Saving makes the new print file(s), adds the edited line (same product, quantity and other properties) and then
   removes the old one, so a failed save never loses the customer's line; the extra-designs charge follows the designs.
   Outside the product page the editor kit (renderer, editor, manager, fonts, ready-made texts) loads on the first tap
   from <template id="pmCartEditKit"> (snippets/pampas-cart-edit.liquid). The link's href stays as a fallback. */
(function () {
  if (window.PMCartEdit) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* the extra-design charge's exact variant (snippets/pampas-addon-map.liquid, key design, rendered by snippets/pampas-cart-edit.liquid) */
  var FEE_VARIANT = window.PMAddonMap && window.PMAddonMap.design && window.PMAddonMap.design.ok ? window.PMAddonMap.design.v : null;
  var HEART = 'M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z';
  var HEADING_TPLS = { mizmor: 1, birkat: 1 };
  function toast(t) { if (window.PMToast) window.PMToast(t); }
  function json(url, body) {
    return fetch(root + url, body ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  /* ---------- the kit ---------- */
  var kit = null;
  function loadKit() {
    if (kit) return kit;
    if (window.PMStickerEditor && window.PMDesigns && window.PMSticker) return (kit = Promise.resolve());
    var tpl = document.getElementById('pmCartEditKit');
    if (!tpl) return (kit = Promise.reject(new Error('kit')));
    var frag = document.importNode(tpl.content, true), scripts = [].slice.call(frag.querySelectorAll('script'));
    scripts.forEach(function (s) { s.remove(); });
    document.head.appendChild(frag);
    kit = scripts.reduce(function (p, s) {
      return p.then(function () {
        return new Promise(function (ok, no) {
          var n = document.createElement('script');
          if (s.src) { if (/pampas-sticker\.js/.test(s.src) && window.PMSticker) return ok(); n.src = s.src; n.onload = ok; n.onerror = no; document.head.appendChild(n); }
          else { n.textContent = s.textContent; document.head.appendChild(n); ok(); }
        });
      });
    }, Promise.resolve()).then(function () {
      /* the editor and manager wait for DOMContentLoaded; here it has passed, so give them a tick */
      return new Promise(function (ok) { setTimeout(ok, 30); });
    }).then(function () { if (document.fonts && document.fonts.ready) return document.fonts.ready; });
    kit.catch(function () { kit = null; });
    return kit;
  }

  /* ---------- models (same as editorModelFrom() in assets/pampas-sticker-pdp.js) ---------- */
  function cleanRm(rm) {
    rm = JSON.parse(JSON.stringify(rm || {}));
    var lost = (rm.logo && !/^data:image\//.test(String(rm.logo)));
    if (lost) rm.logo = null;
    var ex = rm.extras || []; rm.extras = ex.filter(function (x) { return x.type !== 'logo' || /^data:image\//.test(x.src || ''); });
    if (rm.extras.length < ex.length) lost = true;
    rm._lost = lost;
    /* Ran 20.10: the candle's sticker is a 5 cm circle; a line saved with the old 3×4 label is re-edited and printed round, refitted to the circle */
    if (rm.shape === 'label34') {
      var ts = (rm.style || {}).text || {};
      rm.shape = 'round'; rm.size_cm = 5;
      if (window.PMSticker) rm.fit = window.PMSticker.fit(rm.body, !!rm.heading, !!rm.from, { bold: !!(rm.bold || {}).text, box: ts.box === 'frame' || ts.box === 'fill', round: true });
    }
    return rm;
  }
  function editorModelFrom(d) {
    var ex = (d.extras || []).filter(function (x) { return x.type !== 'logo' || /^data:image\//.test(x.src || ''); });
    var xid = 0; ex.forEach(function (x) { var n = parseInt(String(x.k || '').replace(/\D/g, ''), 10); if (n > xid) xid = n; });
    function merge(a, b) { var o = {}; Object.keys(a).forEach(function (k) { o[k] = a[k]; }); Object.keys(b || {}).forEach(function (k) { if (b[k] != null) o[k] = b[k]; }); return o; }
    return {
      tpl: d.tpl || (d.center ? 'free' : 'toda'), body: d.body || '', bodyOff: !d.body && !!d.bodyOff, from: d.from || '', fromShown: !!d.from,
      headingText: d.heading ? d.heading : null, headingOff: !d.heading && !!HEADING_TPLS[d.tpl],
      font: merge({ text: 'Secular One', from: 'Secular One' }, d.font), bold: merge({ text: false, from: false }, d.bold),
      size: merge({ text: 1, from: 1, heart: 1, logo: 1 }, d.size), pos: merge({ text: [0, 0], from: [0, 0], heart: [0, 0], logo: [0, 0] }, d.pos),
      style: d.style ? JSON.parse(JSON.stringify(d.style)) : undefined,
      heart: { on: !!(d.heart && d.heart.on), type: (d.heart && d.heart.type) || 'heart', d: (d.heart && d.heart.d) || HEART },
      logo: typeof d.logo === 'string' && /^data:image\//.test(d.logo) ? d.logo : null,
      extras: ex.map(function (x) { return { k: x.k, type: x.type, type2: x.type2, text: x.text, d: x.d, src: x.src }; }), xid: xid
    };
  }
  function textOf(rm) { return window.PMSticker && window.PMSticker.textOf ? window.PMSticker.textOf(rm) : [rm.heading, rm.body, rm.from].map(function (x) { return String(x || '').trim(); }).filter(Boolean).join('\n'); }
  function strip(m) { return JSON.parse(JSON.stringify(m || {}, function (k, v) { if (k === '_lost') return undefined; return (k === 'logo' || k === 'src') && typeof v === 'string' && v.length > 200 ? '[תמונה מצורפת]' : v; })); }
  function pdfOf(rm, name) { return window.PMSticker.toCanvas(rm).then(function (c) { return new File([window.PMSticker.toPDF(c)], name, { type: 'application/pdf' }); }); }
  /* Ran 21.10: "נר / נרות" only for products in snippets/pampas-candle-mock-list.liquid, else "יחידה / יחידות" (as assets/pampas-designs.js) */
  function summaryOf(list, cand) {
    var a = 1;
    return list.map(function (d, i) {
      var b = a + d.n - 1, r = d.n === 1 ? (cand ? 'נר ' : 'יחידה ') + a : (cand ? 'נרות ' : 'יחידות ') + a + '–' + b; a = b + 1;
      var t = textOf(d.rm).replace(/\s+/g, ' ').trim() || ((d.rm.logo || (d.rm.extras || []).length) ? '(לוגו)' : '—');
      return (i + 1) + '. ' + t + ' — ' + r;
    }).join(' | ');
  }

  /* ---------- replace the line ---------- */
  /* F4 (Ran 21.10): the edited line carries the same property names and values as a line added on the product page
     (snippets/pampas-dedication.liquid approveCurrent + assets/pampas-personalization-print.js generate / setDesignProperties
     for one design; assets/pampas-designs.js beforeAdd for several), in the same order. The old line's design properties are
     rebuilt, never copied; anything else on it (other apps, logo upload facts) is kept. One value differs on purpose: for one
     design the hidden _מקור אישור העיצוב says "נערך בעגלה" (the product page writes how it was approved there); the
     several-designs line has no _מקור, as on the product page. */
  var PRINT_NAME = 'כרטיס-ברכה-A6-מוכן-להדפסה.pdf', PRINT_FORMAT = 'A6, 300 DPI, PDF', PRINT_SIZE = '1240×1748 פיקסלים';
  var DESIGN_KEYS = /^(טקסט הקדשה|תבנית|פונט|לב מצויר|סוג עיצוב|_מקור אישור העיצוב|_עיצוב|אלמנטים נוספים|קובץ PDF.*|קובץ הדפסה.*|פורמט הדפסה.*|מידות קובץ.*|אופן חלוקת ההקדשות|מספר עיצובים שונים|עיצובים|_עיצובים|נוסחים לפי מוצר|חיוב עיצובים נוספים|_מוצרים שאושרו בהוספה לעגלה|_טקסטים)$/;
  function propsFor(item, list) {
    var many = list.length > 1, d1 = list[0].rm, p = item.properties || {}, out = [];
    function put(k, v) { out.push([k, v]); }
    if (many) {
      put('עיצובים', summaryOf(list, !!(window.PMCandleMock && window.PMCandleMock.on(item.handle))));
      put('_עיצובים', JSON.stringify({ v: 1, n: list.map(function (d) { return d.n; }), d: list.slice(1).map(function (d) { return strip(d.rm); }) }));
      put('טקסט הקדשה', textOf(d1) || 'ללא טקסט');
      put('_עיצוב', JSON.stringify(strip(d1)));
    } else {
      var T = (window.pmTemplates || {})[d1.tpl] || null;
      put('טקסט הקדשה', textOf(d1) || 'ללא טקסט');
      put('תבנית', T && T.label ? T.label : (p['תבנית'] || d1.tpl || ''));
      put('פונט', (d1.font && d1.font.text) || 'Secular One');
      put('לב מצויר', d1.heart && d1.heart.on && !(T && T.noHeart) ? 'כן' : 'לא');
      put('סוג עיצוב', p['סוג עיצוב'] || 'מדבקת הקדשה');
      put('_מקור אישור העיצוב', 'נערך בעגלה');
      var sm = strip(d1); put('_עיצוב', JSON.stringify(sm));
      if ((sm.extras || []).length) put('אלמנטים נוספים', String(sm.extras.length));
    }
    /* the rest of the old line, as it was */
    Object.keys(p).forEach(function (k) { if (!DESIGN_KEYS.test(k) && p[k] != null && p[k] !== '') put(k, p[k]); });
    return out;
  }
  /* ---------- which line an add-on belongs to (Ran 21.10, R2) ----------
     Every path that adds a line with add-ons tags them: the product line carries a hidden _pm_line id and each add-on
     (and the extra-designs charge) a matching _parent_line (product page, quick design, cart upsell and greeting sheet,
     cart edit). A line without _pm_line (a cart from before this change) is known by its print file's upload name
     ("F" + the name), so the cart upsell can point at it too. The same rule is in snippets/cart-item.liquid:
       1. an add-on whose _parent_line matches a product line's id belongs to that line;
       2. otherwise (no tag, or the tagged line is gone) the nearest product line in the cart order, among the lines whose
          variant is the add-on's _parent_variant when one is; an untagged add-on looks at the untagged lines first.
     Lines are compared by variant and properties (vsig), since Shopify can change a line's key when the cart is re-priced. */
  function sig(i) { var p = (i && i.properties) || {}, t = JSON.stringify(Object.keys(p).sort().map(function (k) { return [k, p[k]]; })), h = 5381; for (var n = 0; n < t.length; n++) h = ((h << 5) + h + t.charCodeAt(n)) | 0; return (h >>> 0).toString(36) + '.' + t.length; }
  function vsig(i) { return (i && i.variant_id) + '|' + sig(i); }
  function newId() { return 'L' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function lineId(i) {
    var p = (i && i.properties) || {};
    if (p._pm_line) return String(p._pm_line);
    for (var k in p) { var v = p[k] == null ? '' : String(p[k]); if (k.indexOf('קובץ PDF') > -1 && v.indexOf('/') > -1) return 'F' + v.split('/uploads/').pop(); }
    return '';
  }
  function isParent(i, h) { return !!i && i.handle === h && !(i.properties && i.properties._linked_to); }
  /* the extra-designs charge: flagged, or (older carts, FAIL-C) the charge variant with its extra-designs count */
  function isFee(i) { var q = (i && i.properties) || {}; return (!FEE_VARIANT || i.variant_id === FEE_VARIANT) && !!(q._pm_distinct_design_charge || q['מספר עיצובים נוספים']); }
  /* designs summaries compare with either wording ("נרות 1–2" from before 21.10, "יחידות 1–2" now) */
  function normSum(t) { return String(t || '').replace(/(^|[^א-ת])נרות /g, '$1יחידות ').replace(/(^|[^א-ת])נר /g, '$1יחידה '); }
  function sumOf(i) { var p = (i && i.properties) || {}; return normSum(p['עיצובים'] || p['נוסחים לפי מוצר'] || ''); }
  function owner(items, idx) {
    var a = items[idx], ap = (a && a.properties) || {}, h = ap._linked_to, pl = ap._parent_line != null ? String(ap._parent_line) : '';
    var P = []; items.forEach(function (c, k) { if (isParent(c, h)) P.push(k); });
    if (!P.length) return '';
    var C = P;
    /* several lines with the same id (should not happen; defensive): the nearest of them */
    if (pl) { var M = P.filter(function (k) { return lineId(items[k]) === pl; }); if (M.length) C = M; }
    if (C === P) {
      if (!(ap._parent_line != null && String(ap._parent_line))) { var U = P.filter(function (k) { return !(items[k].properties || {})._pm_line; }); if (U.length) C = U; }
      var pv = ap._parent_variant != null ? String(ap._parent_variant) : '';
      if (pv) { var V = C.filter(function (k) { return String(items[k].variant_id) === pv; }); if (V.length) C = V; }
    }
    var best = C[0], bd = Math.abs(C[0] - idx);
    C.forEach(function (k) { var d = Math.abs(k - idx); if (d < bd) { bd = d; best = k; } });
    return items[best].key;
  }
  /* a charge belongs to a line by its tag, else by the designs summary it was added with, else by the rule above */
  /* 0: not this line's; 1: this line's; 2: shared by summary with another line of the same designs */
  function feeMine(items, k, cur) {
    var q = items[k].properties || {}, h = cur.handle, pl = q._parent_line ? String(q._parent_line) : '';
    if (pl && items.some(function (c) { return isParent(c, h) && lineId(c) === pl; })) return owner(items, k) === cur.key ? 1 : 0;
    var fs = normSum(q['נוסחים לפי מוצר'] || '');
    if (fs) { var s = items.filter(function (c) { return isParent(c, h) && sumOf(c) === fs; }); if (s.length) return !s.some(function (c) { return c.key === cur.key; }) ? 0 : s.length > 1 ? 2 : 1; }
    return owner(items, k) === cur.key ? 1 : 0;
  }
  /* the line's extra designs: from _עיצובים, else (older lines) מספר עיצובים שונים − 1, else the entries in נוסחים לפי מוצר − 1 */
  function extraOf(i) {
    var p = (i && i.properties) || {}, m = null; try { m = p['_עיצובים'] ? JSON.parse(p['_עיצובים']) : null; } catch (e) {}
    if (m && m.n && m.n.length) return m.n.length - 1;
    var d = parseInt(p['מספר עיצובים שונים'], 10); if (d > 1) return d - 1;
    var t = String(p['נוסחים לפי מוצר'] || '').trim(); return t ? Math.max(0, t.split(' | ').length - 1) : 0;
  }
  /* what replacing line `cur` (in `items`, the cart before the new line was added) takes along: the add-ons it owns that
     do not carry T yet are added again with _parent_line T and the originals removed; its charge lines are removed (a charge
     shared with an identical line drops by this line's extra designs only) */
  function plan(items, cur, T) {
    var h = cur.handle, copies = [], retire = [], fees = [], left = extraOf(cur), cid = lineId(cur);
    items.forEach(function (a, k) {
      var q = a.properties || {};
      if (q._linked_to !== h) return;
      if (isFee(a)) {
        var m = feeMine(items, k, cur);
        if (!m) return;
        /* a charge shared with another line of the same designs: only this line's part goes, and none when that part is unknown */
        if (m === 2 && left <= 0) return;
        var own = m === 1 && !!q._parent_line && String(q._parent_line) === cid, nq = 0;
        if (!own && left > 0 && a.quantity > left) { nq = a.quantity - left; left = 0; } else if (!own) left = Math.max(0, left - a.quantity);
        fees.push({ vs: vsig(a), q: nq });
        return;
      }
      if (owner(items, k) !== cur.key || String(q._parent_line || '') === T) return;
      var props = {}; Object.keys(q).forEach(function (n) { props[n] = q[n]; }); props._parent_line = T;
      copies.push({ id: a.variant_id, quantity: a.quantity, properties: props });
      retire.push({ vs: vsig(a) });
    });
    return { copies: copies, retire: retire, fees: fees };
  }
  /* the cart updates that finish a replace, read on the cart after the adds (lines matched by vsig, new lines never touched) */
  function finish(after, P, oldVs, newKey, oldQty, feeVs, feeQty) {
    var u = {};
    function at(vs) { return after.filter(function (i) { return vsig(i) === vs; })[0]; }
    var old = at(oldVs);
    if (old) u[old.key] = old.key === newKey ? oldQty : 0;
    P.retire.forEach(function (r) { var l = at(r.vs); if (l) u[l.key] = 0; });
    P.fees.forEach(function (f) { var l = at(f.vs); if (l) u[l.key] = f.vs === feeVs ? feeQty : f.q; });
    return u;
  }
  /* undo an edit that failed half way (Ran 21.10 review): exactly what this edit added comes off again, by line (vsig) and
     by the quantity it added; a line the edit did not add to is never written. U.adds = [{ vs, n }]; U.pf = the product
     line's add got no answer, so the new line is found as the line with this edit's id that was not in the cart before.
     Nothing is undone when the old product line is already gone: then the removal went through and the edit is complete. */
  function restore(U) {
    return json('cart.js').then(function (c) {
      var items = c.items || [], u = {}, had = {};
      (U.before || []).forEach(function (s) { had[s] = 1; });
      if (!items.some(function (i) { return vsig(i) === U.old; })) return 'applied';
      function take(l, n) { if (!l) return; var q = (l.key in u ? u[l.key] : l.quantity) - n; u[l.key] = Math.max(0, q); }
      (U.adds || []).forEach(function (a) { take(items.filter(function (i) { return vsig(i) === a.vs; })[0], a.n); });
      if (U.pf) take(items.filter(function (i) { var p = i.properties || {}; return String(p._pm_line || '') === U.line && !p._linked_to && !had[vsig(i)]; })[0], U.q);
      Object.keys(u).forEach(function (k) { var l = items.filter(function (i) { return i.key === k; })[0]; if (l && l.quantity === u[k]) delete u[k]; });
      if (!Object.keys(u).length) return 'same';
      return json('cart/update.js', { updates: u }).then(function () { return 'restored'; });
    });
  }
  /* the undo could not run (offline): it is kept and runs when the connection is back or on the next page, never while an
     edit is running. A new edit runs it first (force); it is dropped only once it ran (or found nothing to undo) or expired.
     If the forced run fails too, the undo is kept and the new edit stops with the standard error (re-review of 151fb75). */
  var UNDO = 'pmEditUndo', inflight = {};
  function readUndo() { var U = null; try { U = JSON.parse(sessionStorage.getItem(UNDO) || 'null'); } catch (e) {} if (U && Date.now() - U.t > 30 * 60 * 1000) { dropUndo(); U = null; } return U; }
  function dropUndo() { try { sessionStorage.removeItem(UNDO); } catch (e) {} }
  function recover(force) {
    var U = readUndo();
    if (!U || (!force && Object.keys(inflight).length)) return Promise.resolve();
    return restore(U).then(function (r) { dropUndo(); if (r === 'restored' && !force) rebuild(); }, function (e) { if (force) throw e || new Error('undo'); });
  }
  window.addEventListener('online', function () { setTimeout(function () { recover(); }, 800); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { recover(); }); else setTimeout(function () { recover(); }, 0);
  /* a short message the customer sees, also where the toast script is not on the page yet (the cart page before an edit) */
  function say(t) {
    if (window.PMToast) return window.PMToast(t);
    var tpl = document.getElementById('pmCartEditKit'), s = tpl && tpl.content.querySelector('script[src*="pampas-toast"]');
    if (!s) return;
    var n = document.createElement('script'); n.src = s.src; n.onload = function () { if (window.PMToast) window.PMToast(t); }; document.head.appendChild(n);
  }
  /* the end of a replace made by a product-page add (the edit route on the product page, and the cart page after a full-page
     post): `old` is the old line in `items` (the cart now), `had` the vsigs of the lines before the add, `T` the new line's id.
     The old line's add-ons are added again for T (if that fails they stay), then the old line, those originals and the old
     charge go in one update (one retry). If that update fails, this add is taken off again (lines with T that were not
     there before; one retry) and the customer sees the same error as in a cart edit. Resolves 'ok' or 'failed'. */
  function post(u, b) { return fetch(root + u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (r) { if (!r.ok) throw new Error(u); return r; }); }
  function twice(f) { return f().catch(function () { return new Promise(function (ok) { setTimeout(ok, 900); }).then(f); }); }
  function finishReplace(items, old, T, had) {
    var H = {}; (had || []).forEach(function (x) { H[x] = 1; });
    var prior = items.filter(function (i) { return H[vsig(i)]; });
    var P = plan(prior, old, T), u = finish(items, P, vsig(old), null, 0, '', 0);
    var copies = P.copies.length ? post('cart/add.js', { items: P.copies }).catch(function () {
      P.retire.forEach(function (m) { items.forEach(function (i) { if (vsig(i) === m.vs) delete u[i.key]; }); });
    }) : Promise.resolve();
    /* the retry first reads the cart: an update whose answer was lost may have gone through, and Shopify reads a key that is no
       longer in the cart as its variant id, so resending it would set every line of that variant to 0 (the new line too) */
    var applied = false;
    function update() {
      return post('cart/update.js', { updates: u }).catch(function () {
        return new Promise(function (ok) { setTimeout(ok, 900); }).then(function () { return json('cart.js'); }).then(function (c) {
          var items = c.items || [], v = {};
          if (!items.some(function (i) { return vsig(i) === vsig(old); })) { applied = true; return null; }
          Object.keys(u).forEach(function (k) { if (items.some(function (i) { return i.key === k; })) v[k] = u[k]; });
          return post('cart/update.js', { updates: v });
        });
      });
    }
    return copies.then(update).then(function () { return 'ok'; }, function () {
      return twice(function () {
        return json('cart.js').then(function (c) {
          /* the update's answer was lost but the old line is gone: the update went through, the new line stays (as restore's 'applied') */
          if (!(c.items || []).some(function (i) { return vsig(i) === vsig(old); })) { applied = true; return null; }
          var b = {};
          (c.items || []).forEach(function (i) { var p = i.properties || {}; if (!H[vsig(i)] && (String(p._pm_line || '') === T || String(p._parent_line || '') === T)) b[i.key] = 0; });
          return Object.keys(b).length ? post('cart/update.js', { updates: b }) : null;
        });
      }).catch(function () {}).then(function () { if (applied) return 'ok'; say('לא הצלחנו לעדכן את העגלה. נסו שוב.'); return 'failed'; });
    });
  }
  window.PMCartLine = { sig: sig, vsig: vsig, newId: newId, lineId: lineId, owner: owner, isFee: isFee, plan: plan, finish: finish, say: say, finishReplace: finishReplace, extraOf: extraOf };

  /* ---------- replace the line ---------- */
  function replace(item, list) {
    /* a second tap on save while the first is still working gets the same promise, not a second line */
    if (inflight[item.key]) return inflight[item.key];
    var pr = doReplace(item, list);
    inflight[item.key] = pr;
    var done = function () { delete inflight[item.key]; };
    pr.then(done, done);
    return pr;
  }
  function doReplace(item, list) {
    var many = list.length > 1, sent = false, before = null, cur = null, T = '', P = null, newKey = null, feeProps = null, adds = [], pf = false, extra = [];
    /* an undo kept from an earlier failed edit runs first and is then dropped, so it never touches this edit */
    return recover(true).then(function () { return json('cart.js'); }).then(function (c) {
      before = c.items || [];
      cur = before.filter(function (i) { return i.key === item.key; })[0] || before.filter(function (i) { return vsig(i) === vsig(item); })[0];
      if (!cur) throw new Error('line');
      var p = cur.properties || {};
      /* a line's id is kept across edits, except an id made from a plain line's properties (P…): the same plain product added
         again later would get it too, so the edited line gets its own */
      T = p._pm_line && !/^P/.test(String(p._pm_line)) ? String(p._pm_line) : newId();
      P = plan(before, cur, T);
      var fd = new FormData();
      fd.append('id', String(cur.variant_id)); fd.append('quantity', String(cur.quantity));
      var props = propsFor(cur, list), sum = many ? props[0][1] : '';
      /* R2: the line keeps its id across edits (it is one of "the rest" of its properties); a line without one, or with a P id, gets T */
      if (String(p._pm_line || '') !== T) { props = props.filter(function (kv) { return kv[0] !== '_pm_line'; }); props.push(['_pm_line', T]); }
      if (many) feeProps = { _linked_to: cur.handle, _parent_variant: String(cur.variant_id), _pm_distinct_design_charge: '1', 'מספר עיצובים נוספים': String(list.length - 1), 'נוסחים לפי מוצר': sum, _parent_line: T };
      /* for several designs the product page sends the files after עיצובים / _עיצובים; one design: after _עיצוב / אלמנטים נוספים */
      var head = many ? 2 : props.filter(function (kv) { return DESIGN_KEYS.test(kv[0]); }).length;
      props.slice(0, head).forEach(function (kv) { fd.append('properties[' + kv[0] + ']', kv[1]); });
      return Promise.all(list.map(function (d, i) { return pdfOf(d.rm, many ? 'עיצוב-' + (i + 1) + '-מדבקה-עגולה-5cm.pdf' : PRINT_NAME); })).then(function (fs) {
        fs.forEach(function (f, i) {
          fd.append(many ? 'properties[קובץ PDF לעיצוב ' + (i + 1) + ']' : 'properties[קובץ PDF מוכן להדפסה]', f);
          /* several designs: each file's format and size beside it, as the product page writes them (pampas-personalization-print.js unitPrintMeta) */
          if (many) { fd.append('properties[פורמט הדפסה — עיצוב ' + (i + 1) + ']', PRINT_FORMAT); fd.append('properties[מידות קובץ — עיצוב ' + (i + 1) + ']', PRINT_SIZE); }
        });
        if (!many) {
          fd.append('properties[פורמט הדפסה]', PRINT_FORMAT); fd.append('properties[מידות קובץ]', PRINT_SIZE);
          fd.append('properties[אופן חלוקת ההקדשות]', 'אותה הקדשה לכל ' + cur.quantity + ' המוצרים');
          fd.append('properties[מספר עיצובים שונים]', '1');
        }
        props.slice(head).forEach(function (kv) { fd.append('properties[' + kv[0] + ']', kv[1]); });
        return fd;
      });
    }).then(function (fd) {
      /* Codex G3-r4 (P2): the edited line goes in first; nothing old is removed unless every add succeeded */
      sent = true; pf = true;
      return fetch(root + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
    }).then(function (r) { if (!r.ok) { pf = false; throw new Error('add'); } return r.json(); }).then(function (added) {
      var line = added && (added.key ? added : added.items && added.items[0]);
      newKey = line && line.key;
      if (line && line.properties) { adds.push({ vs: vsig(line), n: cur.quantity }); pf = false; }
      /* the new charge and the add-ons that move to this line, in one request */
      extra = P.copies.slice();
      if (feeProps) extra.unshift({ id: FEE_VARIANT, quantity: list.length - 1, properties: feeProps });
      return extra.length ? json('cart/add.js', { items: extra }).then(function () { extra.forEach(function (x) { adds.push({ vs: x.id + '|' + sig(x), n: x.quantity }); }); }) : null;
    }).then(function () { return json('cart.js'); }).then(function (c) {
      var u = finish(c.items || [], P, vsig(cur), newKey, cur.quantity, feeProps ? FEE_VARIANT + '|' + sig({ properties: feeProps }) : '', list.length - 1);
      return Object.keys(u).length ? json('cart/update.js', { updates: u }) : null;
    }).then(function () {
      /* REQ-027 (Ran 23.10): a sticker add-on of this line carries its own copy of the text (טקסט, read by the order); after a
         one-design edit it gets the new text. Best effort: the product line, its print file and the cart are already right */
      if (many) return null;
      var nt = textOf(list[0].rm);
      return json('cart.js').then(function (c) {
        var st = (c.items || []).filter(function (i) { var q = i.properties || {}; return String(q._parent_line || '') === T && q['סוג עיצוב'] === 'מדבקת הקדשה' && !isFee(i) && q['טקסט'] != null && q['טקסט'] !== nt; });
        var one = function (i) { var np = {}; Object.keys(i.properties).forEach(function (k) { np[k] = i.properties[k]; }); np['טקסט'] = nt; return json('cart/change.js', { id: i.key, quantity: i.quantity, properties: np }); };
        /* Codex adversarial 2 (#1): one retry; if the sticker still has the old text the customer is told, never "updated" */
        return st.reduce(function (pr, i) { return pr.then(function () { return one(i).catch(function () { return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return one(i); }); }); }); }, Promise.resolve());
      }).then(function () { return true; }, function () { return false; });
    }).then(function (ok) { rebuild(); toast(ok === false ? 'לא הצלחנו לעדכן את המדבקה. נסו שוב את העריכה.' : 'ההקדשה עודכנה בעגלה'); }, function (err) {
      if (!sent) throw err;
      /* F4: whatever failed after the first add, the cart goes back to how it was (one retry), then the drawer / cart page
         shows the cart as it now is. The cart page reloads only when the cart differs from what it shows, so the error stays readable. */
      var U = { t: Date.now(), old: vsig(cur), line: T, adds: adds, pf: pf, q: cur.quantity, before: before.map(vsig) };
      var keep = function () { try { sessionStorage.setItem(UNDO, JSON.stringify(U)); } catch (e) {} };
      /* offline: nothing can be read or undone now; the undo runs when the connection is back (recover) and the cart on screen stays */
      if (navigator.onLine === false) { keep(); throw err; }
      var undo = function () { return restore(U); };
      return undo().catch(function () { return new Promise(function (ok) { setTimeout(ok, 900); }).then(undo); }).then(function (r) {
        if (r === 'applied') { rebuild(); toast('ההקדשה עודכנה בעגלה'); return 'ok'; }
      }, keep).then(function (ok) {
        if (ok === 'ok') return;
        if (!document.body.classList.contains('template-cart')) { rebuild(); throw err; }
        return json('cart.js').then(function (c) {
          var keys = (c.items || []).map(function (i) { return i.key; }).sort().join('|'), shown = [].slice.call(document.querySelectorAll('[data-key], [data-linked-addon-key]')).map(function (e) { return e.getAttribute('data-key') || e.getAttribute('data-linked-addon-key'); });
          var same = (c.items || []).every(function (i) { return shown.indexOf(i.key) > -1; }) && shown.filter(function (x, n, a) { return a.indexOf(x) === n; }).every(function (x) { return keys.indexOf(x) > -1; });
          if (!same) rebuild();
        }, function () {}).then(function () { throw err; });
      });
    });
  }
  function rebuild() {
    if (document.body.classList.contains('template-cart')) { setTimeout(function () { location.reload(); }, 400); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* ---------- open ---------- */
  var busy = false;
  function edit(key, link) {
    if (busy) return; busy = true;
    if (link) link.setAttribute('aria-busy', 'true');
    Promise.all([loadKit(), json('cart.js')]).then(function (r) {
      var item = (r[1].items || []).filter(function (i) { return i.key === key; })[0];
      if (!item || !item.properties || !item.properties['_עיצוב']) throw new Error('line');
      var rm1 = cleanRm(JSON.parse(item.properties['_עיצוב'])), lost = rm1._lost;
      /* Ran 21.10 (dedication display): the editor's candle photo only for listed products (snippets/pampas-candle-mock-list.liquid) */
      var CM = window.PMCandleMock, cand = !!(CM && CM.on(item.handle)), kb = document.querySelector('span[data-pm-blank]:not(#pmQdBlank)');
      if (kb && !document.querySelector('[data-pm-spdp]')) kb.dataset.blank = cand ? CM.src : '';
      var multi = null; try { multi = item.properties['_עיצובים'] ? JSON.parse(item.properties['_עיצובים']) : null; } catch (e) {}
      /* Codex G3-r4 (P1): a line from the earlier per-unit flow (per-product wording or per-unit files, no usable _עיצובים) would collapse into one design here: send it to the product page instead */
      if (!(multi && multi.n && multi.n.length > 1)) {
        var pr = item.properties, legacy = !!pr['נוסחים לפי מוצר'] || Object.keys(pr).some(function (k) { return k.indexOf('קובץ PDF למוצר') > -1; });
        if (legacy) throw new Error('legacy');
      }
      if (multi && multi.n && multi.n.length > 1) {
        var list = [{ n: multi.n[0], rm: rm1, M: editorModelFrom(rm1) }];
        (multi.d || []).forEach(function (d, k) { var rm = cleanRm(d); if (rm._lost) lost = true; list.push({ n: multi.n[k + 1] || 1, rm: rm, M: editorModelFrom(rm) }); });
        window.PMDesigns.openFor({ qty: item.quantity, list: list, candle: cand, onSave: function (l) { return replace(item, l).catch(function () { throw new Error('לא הצלחנו לעדכן את העגלה. נסו שוב.'); }); } });
      } else {
        window.PMStickerEditor.open({ design: { editor: editorModelFrom(rm1), title: 'עריכת ההקדשה · ' + item.quantity + ' ' + (cand ? (item.quantity === 1 ? 'נר' : 'נרות') : (item.quantity === 1 ? 'יחידה' : 'יחידות')),
          onSave: function (M, rm) { toast('מעדכנים את העגלה…'); replace(item, [{ n: item.quantity, rm: rm, M: M }]).catch(function () { toast('לא הצלחנו לעדכן את העגלה. נסו שוב.'); }); } } });
      }
      if (lost) setTimeout(function () { toast('הלוגו לא נשמר בעגלה. כדי לשמור אותו, העלו אותו שוב.'); }, 400);
    }).catch(function () { if (link && link.href) location.href = link.href; })
      .then(function () { busy = false; if (link) link.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.pm-gift__edit'); if (!a) return;
    var m = /#pm-edit=(.+)$/.exec(a.getAttribute('href') || ''); if (!m) return;
    e.preventDefault(); e.stopPropagation();
    edit(decodeURIComponent(m[1]), a);
  }, true);

  window.PMCartEdit = { edit: edit, version: '1.0.0' };
})();
